import React, {useState, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { getAdditionalSpecialsApi } from 'api/subscription';
import {
  Button,
  Icon,
  Typography,
  DialogContent,
  Dialog,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import SpecialsList from './SpecialsList';
import SpecialsForm from './SpecialsForm';


const Specials = () => {
  const dispatch = useDispatch();
  const [special, setSpecial] = useState();

  useEffect(() => {
    getAdditionalSpecialsApi({ dispatch });
  }, []);

  return (
    <Accordion
      elevation={25}
      className="mb-4"
    >
      <AccordionSummary
        expandIcon={<Icon>expand_more</Icon>}
      >
        <Typography variant="h5" className="text-brand m-2" title="Additional Specials">Additional Specials</Typography>
      </AccordionSummary>
      <AccordionDetails className="block">
        <SpecialsList setSpecial={setSpecial} />
        <Button
          color="primary"
          variant="contained"
          onClick={() => setSpecial({})}
          className="mb-8 ml-4"
        >
          <Icon className="mr-2">add</Icon>
          <span>Add New Specials</span>
        </Button>
        <Dialog
          open={special}
          onClose={() => setSpecial(null)}
          maxWidth={'md'}
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h4" className="mt-4">{special?._id ? 'Edit Additional Special' : 'Create Additional Specials'}</Typography>
          </DialogTitle>
          <DialogContent  className="m-4">
            <SpecialsForm special={special} setSpecial={setSpecial} />
          </DialogContent>
        </Dialog>
      </AccordionDetails>
    </Accordion>
  );
};

export default Specials;
